<template>
  <div class="RelaxifyFooter" id="relaxifyFooter">
    <div class="RelaxifyFooter__blue-part--wrapper">
      <div class="RelaxifyFooter__blue-part">
        <img loading="lazy" class="RelaxifyFooter__yellow-dot" width="38" height="37" :src="yellowCircleImage"
             alt="yellow circles"/>
        <img loading="lazy" class="RelaxifyFooter__blue-dot" width="30" height="27" :src="blueCircleImage"
             alt="Blue dot"/>
        <div v-if="currentPath === corporate" class="RelaxifyFooter__h6-title"> {{ corporateUpperTitle }}</div>
<!--        <div v-else class="RelaxifyFooter__h6-title"> {{ upperTitle }}</div>-->
        <h1 v-if="currentPath === corporate" class="RelaxifyFooter__h2-title"> {{ corporateMainTitle }} </h1>
        <h3 v-else class="RelaxifyFooter__h2-title"> {{ mainTitle }} </h3>
        <span v-if="currentPath === corporate" class="RelaxifyFooter__description"> {{ corporateDescription }} </span>
        <span v-else class="RelaxifyFooter__description"> {{ description }} </span>
<!--        <a-->
<!--            class="RelaxifyFooter__mobile_stores"-->
<!--            href="https://play.google.com/store/apps/details?id=org.relaxifyapp.me&referrer=utm_source%3Dwebplay">-->
<!--          <img loading="lazy" alt="Google play" :src="googlePlayLogo">-->
<!--        </a>-->
<!--        <a class="RelaxifyFooter__mobile_stores"-->
<!--           href="https://apps.apple.com/us/app/relaxyfyapp/id1573210878">-->
<!--          <img loading="lazy" alt="App store" :src="appStoreLogo"/>-->
<!--        </a>-->
        <RelaxifyButton color="primary"> {{ corporateButtonTitle }}</RelaxifyButton>
        <span class="RelaxifyFooter__description"> {{ talkToUs}} </span>
        <img loading="lazy" class="RelaxifyFooter__flower" alt="Relaxify flower" :src="flowerLogo"/>
      </div>
    </div>
    <div v-if="currentPath !== corporate" class="RelaxifyFooter__investors__eu__institutions">
      <div class="RelaxifyFooter__investors__eu__institutions__logos">
        <img loading="lazy" width="157" v-for="(investor, index) in corporateGrowthData.euInstitutionsLogos"
             :key="index"
             :src="investor.logo" :alt="investor.name"/>
      </div>
      <div class="RelaxifyFooter__investors__eu__institutions__descriptions">
        <div v-for="(desc, index) in corporateGrowthData.descriptions" :key=index class="RelaxifyFooter__investors__eu__institutions__desc"> {{ desc }}</div>
      </div>
    </div>
    <div class="RelaxifyFooter__pages-for-redirect">
      <router-link class="RelaxifyFooter__logo" :to="innerLinkToHomePage">
        <img loading="lazy" class="RelaxifyHeader__second-part--logo" alt="Relaxify logo"
             src="../../public/header/relaxify-logo.svg">
      </router-link>
      <div class="RelaxifyFooter__redirect-items">
        <div class="RelaxifyFooter__redirect-item" v-for="(element, index) in menuOptions" :key="index">
          <router-link v-if="element.title !== blog && element.title !== forEmpoyees" :to="element.href">
            <v-list-item-title v-text="element.title"/>
          </router-link>
          <a v-else :href="element.href">
            <v-list-item-title v-text="element.title">
            </v-list-item-title>
          </a>
        </div>
      </div>
      <div class="RelaxifyFooter__redirect-items__mobile">
        <div class="RelaxifyFooter__redirect-item" v-for="(element, index) in menuOptionsMobile" :key="index">
          <router-link v-if="element.title !== blog && element.title !== forEmpoyees" :to="element.href">
            <v-list-item-title v-text="element.title"/>
          </router-link>
          <a v-else :href="element.href">
            <v-list-item-title v-text="element.title">
            </v-list-item-title>
          </a>
        </div>
      </div>
      <div class="RelaxifyFooter__social-icons">
        <a v-for="(icon, index) in socialIcons" :key="index" :href="icon.href">
          <img loading="lazy" class="RelaxifyFooter__social-icon" :alt="icon.title" :src="icon.path"/>
        </a>
      </div>
    </div>
    <v-divider/>
    <div class="RelaxifyFooter__terms">
      <a v-for="(term, index) in terms" :key=index :href="term.href">
        <span> {{ term.title }} </span>
      </a>
    </div>
  </div>
</template>

<script>
import {
  getFooterData, getFooterUpperTitle, getFooterMainTitle,
  getFooterDescription, getFooterRedirectElements, getFooterSocialIcons, getFooterTerms,
  getFooterAppStoreLogo, getFooterGooglePlayLogo, getFooterFlowerLogo,
  getFooterCorporateUpperTitle, getFooterCorporateMainTitle, getFooterCorporateDescription,
  getFooterCorporateButtonTitle, getFooterMenuOptions
} from '../getters/footerGetters'
import resources from "@/resources";
import RelaxifyButton from "@/components/RelaxifyButton";
import {computed} from "vue";
import {getCorporateGrowthData, getCorporatePageData} from "@/getters/corporateGetters";
import {getHeaderData, getHeaderMenuItems} from "@/getters/headerGetters";

export default {
  name: "RelaxifyFooter",
  components: {RelaxifyButton},
  setup() {
    const footerData = getFooterData(resources);
    const headerData = getHeaderData(resources);
    const currentPath = computed(() => window.location.pathname);
    const corporate = '/corporate/';
    const upperTitle = getFooterUpperTitle(footerData);
    const mainTitle = getFooterMainTitle(footerData);
    const description = getFooterDescription(footerData);
    const googlePlayLogo = getFooterGooglePlayLogo(footerData);
    const appStoreLogo = getFooterAppStoreLogo(footerData)
    const flowerLogo = getFooterFlowerLogo(footerData);
    const socialIcons = getFooterSocialIcons(footerData)
    const redirectElements = getFooterRedirectElements(footerData);
    const terms = getFooterTerms(footerData);
    const corporateUpperTitle = getFooterCorporateUpperTitle(footerData);
    const corporateMainTitle = getFooterCorporateMainTitle(footerData);
    const corporateDescription = getFooterCorporateDescription(footerData);
    const corporateButtonTitle = getFooterCorporateButtonTitle(footerData);
    const talkToUs = footerData.talkToUs;
    const menuOptions = getFooterMenuOptions(footerData);
    const menuOptionsMobile = getHeaderMenuItems(headerData);
    const corporatePageData = getCorporatePageData(resources);
    const corporateGrowthData = getCorporateGrowthData(corporatePageData);

    const innerLinkToHomePage = '/';
    const blog = 'Blog';
    const forEmpoyees = 'RelaxifyApp for employees';

    return {
      innerLinkToHomePage,
      socialIcons,
      terms,
      upperTitle,
      mainTitle,
      description,
      googlePlayLogo,
      appStoreLogo,
      redirectElements,
      flowerLogo,
      corporateUpperTitle,
      corporateMainTitle,
      corporateDescription,
      corporateButtonTitle,
      currentPath,
      corporate,
      yellowCircleImage: footerData.yellowCircleImage,
      blueCircleImage: footerData.blueCircleImage,
      menuOptions,
      blog,
      corporateGrowthData,
      talkToUs,
      forEmpoyees,
      menuOptionsMobile
    }
  }
}
</script>

<style lang="scss">

.RelaxifyFooter {

  .RelaxifyButton {
    @media (max-width: 767px) {
      display: block;
    }
    @media (min-width: 912px) {
      display: block;
    }
    @media (min-width: 1024px) {
      display: block;
    }
  }

  &__mobile_stores {
    @media (max-width: 767px) {
      display: none;
    }
    display: block;
  }

  .parent {
    width: 100%;
    height: 200px;
    background-color: #8ae6a2;
    position: relative;
  }

  .child {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #8ae6a2;
    position: absolute;
    bottom: 0px;
    right: 0px;
  }

  &__blue-part {
    @media (min-width: 1440px) {
      padding-top: 75px;
    }

    //@media (max-width: 539px) {
    //  clip-path: circle(73.5% at 50% 38%)
    //}
    //
    //@media (min-width: 540px) {
    //  clip-path: circle(66.5% at 50% 38%);
    //}
    //
    //@media (min-width: 768px ) {
    //  clip-path: circle(106.5% at 50% -18%);
    //}
    //
    //@media (min-width: 820px) {
    //  clip-path: circle(102.5% at 50% -18%);
    //}
    //
    //@media (min-width: 912px) {
    //  clip-path: circle(95.5% at 50% -18%);
    //}
    //
    //@media (min-width: 1024px) {
    //  clip-path: circle(102.5% at 50% -46%);
    //}
    //
    //@media (min-width: 1280px) {
    //  clip-path: circle(115.5% at 50% -97%);
    //}
    //
    //@media (min-width: 1440px) {
    //  clip-path: circle(149% at 50% -162%);
    //}
    //
    //@media (min-width: 1780px) {
    //  clip-path: circle(151% at 50% -220%)
    //}
    //@media (min-width: 1840px) {
    //  clip-path: circle(153% at 50% -231%);
    //}
    //
    //@media (min-width: 1920px) {
    //  clip-path: circle(162% at 50% -265%)
    //}


    background: #5358C2;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    position: relative;

    a:first-of-type {
      margin-bottom: 10px;
    }

    .RelaxifyButton {
      width: 90%;
      margin-bottom: 30px;

      @media (min-width: 1024px) {
        width: 340px;
      }

      button {
        width: 100%;
        height: 50px !important;
        color: #193566 !important;
      }
    }

    //&__ellipse {
    //  width: 314.64px;
    //  height: 111.68px;
    //  background: #5358C2;
    //  position: absolute;
    //  top: 169px;
    //  z-index: -5;
    //  border-radius: 80% / 100% 100% 0% 0%;
    //}
  }

  &__flower {
    margin: 40px 0 -4px 0;

    @media (min-width: 414px) {
      margin-bottom: -18px;
    }

    @media (min-width: 412px) {
      margin-bottom: -16px;
    }
  }

  &__blue-dot {
    @media (min-width: 1024px) {
      width: 50px;
      height: 50px;
      position: absolute;
      top: 180px;
      right: 100px;
    }

    @media (min-width: 1440px) {
      width: 75px;
      height: 75px;
      position: absolute;
      margin-left: 175px;
      margin-top: 90px;
      right: 120px;
      align-self: unset;
    }

    align-self: flex-end;
    margin-right: 35px;
  }

  &__yellow-dot {

    @media (min-width: 1024px) {
      width: 50px;
      height: 50px;
      position: absolute;
      top: 10px;
      left: 130px;
    }

    @media (min-width: 1440px) {
      width: 75px;
      height: 75px;
      position: absolute;
    }

    align-self: flex-start;
    margin-left: 25px;
    margin-top: 25px;
  }

  &__h2-title {
    @media (min-width: 1440px) {
      font-size: 48px;
      max-width: 410px;
      margin-top: 25px;
    }

    font-size: 32px;
    text-align: center;
    color: white;
    font-weight: 700;
    margin: 15px 0 20px 0;
    max-width: 270px;
  }

  &__elipse {
    border-radius: 50% / 0 0 100% 100%;
    min-height: 80px;
    background: #5358C2;
    display: flex;
    justify-content: center;
    margin-top: -1px;
  }

  &__h6-title {
    @media (min-width: 1440px) {
      font-size: 20px;
      max-width: 500px;
      margin-top: 10px;
    }

    font-size: 14px;
    font-weight: 400;
    line-height: 15.4px;
    text-align: center;
    color: white;
  }

  &__description {
    @media (max-width: 1023px) {
      padding: 0 20px;
    }

    @media (min-width: 1024px) {
      max-width: 600px;

      &:nth-of-type(2) {
        margin-bottom: unset;
      }
    }

    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    color: white;
    max-width: 370px;
    text-align: center;
    margin-bottom: 40px;
  }

  &__pages-for-redirect {
    @media (min-width: 1024px) {
      justify-content: space-around;
      display: flex;
      margin-left: unset;

      img {
        margin-right: 145px;
      }
    }
    margin-top: 60px;
    margin-left: 25px;

    img {
      @media (min-width: 1440px) {
        margin-right: 235px;
      }
      margin-bottom: 20px;
    }
  }

  &__redirect-items {
    display: none;
    @media (min-width: 1024px) {
      flex-wrap: wrap;
      display: flex;
      flex-direction: row;
    }
  }

  &__redirect-items__mobile {
    @media (min-width: 1024px) {
    display: none;
    }
  }

  &__redirect-item {
    flex: 35%;

    .v-list-item__title {
      @media (min-width: 1440px) {
        font-size: 22px;
        line-height: 29px;
      }

      margin-bottom: 17px;
      font-size: 16px;
      font-weight: 400;
      color: #193566
    }
  }

  &__social-icons {
    @media (min-width: 1024px) {
      margin: unset;
    }
    margin-top: 35px;

    .RelaxifyFooter__social-icon {
      margin-right: 15px;
    }
  }

  .v-divider {
    margin: 30px 20px 25px 20px;
  }

  &__terms {
    @media (min-width: 1024px) {
      text-align: center;

    }

    margin-left: 25px;

    span {
      @media (min-width: 1024px) {
        font-size: 12px;
      }
      @media (min-width: 1440px) {
        font-size: 14px;
        margin-right: 60px;
        line-height: 18px;
      }

      font-size: 10px;
      color: #193566;
      font-weight: 400;
      margin-right: 25px;
      padding-bottom: 25px;
    }
  }

  &__logo {
    @media (min-width: 1440px) {
      img {
        width: 179px;
        height: 50px;
      }
    }
  }

  a {
    text-decoration: none;
  }

  &__investors__eu__institutions {

    &__logos {
      margin: 20px;

      @media (min-width: 1440px) {
        margin: 50px 100px;
      }
      justify-content: space-between;
      display: flex;
      flex-wrap: wrap;

      img {
        @media (min-width: 360px) {
          height: 90px;
          width: 155px;
        }
        @media (min-width: 600px) {
          height: 160px;
        }

        @media (min-width: 768px) {
          width: 300px;
          height: 140px;
        }
      }

      img:nth-child(1) {
        @media (min-width: 360px) {
          height: 160px;
        }
        @media (min-width: 600px) {
          width: 180px;
          height: 160px;
        }
        @media (min-width: 768px) {
          height: 190px;
          width: 250px;
        }
      }
    }

    &__descriptions {
      display: flex;
      margin-bottom: 90px;

      @media (max-width: 1023px) {
        flex-direction: column;
      }
    }

    &__desc {
      font-size: 20px;
      font-weight: 400;
      line-height: 150%;
      color: #193566;
      margin: 20px auto !important;
      max-width: 484px !important;
      text-align: center !important;
    }
  }
}

</style>
